import React, { useState } from 'react';
import { makeStyles, Select, TextField } from "@material-ui/core";
import {epochSeconds, isHidden} from "../utils/Functions";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import FileDownloadDoneOutlinedIcon from '@mui/icons-material/FileDownloadDoneOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { MenuItem } from "@mui/material";
import {getAccessToken} from "../utils/Auth";
import {toast} from "react-toastify";
import axios from "axios";
import Constants from "../utils/Constants";


// This is a list/table element for Alert options in the AnalyzerDialog


let http_str = "https://"
let base_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/alerts')

const useStyles = makeStyles(theme => ({
    outer_div: {
        minHeight: '100vh',
    },
    card: {
        backgroundColor: '#424242',
        color: '#EEEEEE',
    },
    itemBar: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#222222',
    },
    pageBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        backgroundColor: '#222222',
        color: '#AAAAAA',
    },
    collapsableTableComponent: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px',
        borderBottom: '1px solid #ccc'
    },
    tableComponent: {
        borderStyle: 'solid',
        borderColor: '#000',
        borderRadius: '10px',
        borderSpacing: '0px',
        borderRightWidth: '0px',
        borderTopWidth: '1px',
        borderBottomWidth: '0px',
        borderLeftWidth: '0px',
        // backgroundColor: '#222222' // setting this breaks row highlighting
    },
    tableCell: {
        paddingLeft: '12px',
        paddingRight: '12px',
        borderBottom: '1px solid #444',
        color: '#CCCCCC',
    },
    clickableTableCell: {
        paddingLeft: '12px',
        borderBottom: '1px solid #444',
        cursor: 'pointer',
    },
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        margin: '10',
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

const toastOptions = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true
}

export default function AlertSink({ index, alert_sink, headers, setRequiresSave, handleAlertChange, handleAlertDelete }) {
    const classes = useStyles()
    const [isOpen, setIsOpen] = useState(false);
    const [isSelected, setIsSelected] = useState(false);

    const alert_type_menu = [
        { label: "AWS SNS", value: "AWS SNS", disabled: false },
        { label: "Email", value: "Email", disabled: false },
        { label: "Slack", value: "Slack", disabled: false },
        { label: "Splunk HEC", value: "SPlunk HEC", disabled: true },
        { label: "Syslog", value: "Syslog", disabled: false },
        { label: "Huntress HEC", value: "Huntress HEC", disabled: true },
    ]

    const send_test_alert = async (alert_index, item) => {
        let url = base_url + "?test=" + alert_index
        const http_headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        let params = {
            node_name: item.node_name,
            alert_type: item.alert_type,
            title: item.title,
            description: item.description,
            action_ip_blocked: item.action_ip_blocked,
            action_process_killed: item.action_process_killed,
            action_user_suspended: item.action_user_suspended,
        }
        const toastId = toast.loading('sending test alert...', toastOptions)
        await axios
            .post(url, { 'alert': params },{ headers: http_headers })
            .then(res => {
                // Add the data submitted back to the local table so it is correct before server side refresh
                console.log("response: " + JSON.stringify(res))
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
                // Notification(res.data['msg'], 'info');
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error sending test alert: ${err}`, type: "error", isLoading: false})
                // Notification(`Error: adding new site. ${err}`, 'error');
            })
    }

    const toggleOpen = () => {
        console.log(JSON.stringify(alert_sink))
        setIsOpen(!isOpen);
    };

    const setEnabled = (enabled) => {
        // cannot enable a none type alert
        if (alert_sink.alert_type === "none") {
            setEnabled(false);
            alert_sink.enabled = false;
        }
        else {
            alert_sink.enabled = enabled;
            setRequiresSave()
        }
    }

    const handleSendTest = (event, index) => {
        console.log("handleSendtest()")
        const item = {
            "acked": false,
            "node_name": "test",
            "alert_type": "attack started",
            "title": "test alert from RansomStop",
            "confidence": 100,
            "description": "This is a generated test alert.",
            "action_ip_blocked": false,
            "action_process_killed": false,
            "action_user_suspended": false,

        }
        send_test_alert(index, item)
    }

    function getEnabledButton() {
        if (alert_sink.enabled) {
            return (
                <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}>
                    <CheckCircleOutlinedIcon color={"success"} onClick={(e) => setEnabled(false)} />
                </td>
            )
        }
        else {
            return (
                <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}>
                    <BlockOutlinedIcon color={"error"} onClick={(e) => setEnabled(true)} />
                </td>
            )
        }
    }

    function getSendTestButton() {
        if (alert_sink.alert_type === "Email" || alert_sink.alert_type === "Slack") {
            return (
                <td className={isHidden('send_test', headers) ? classes.hide : classes.clickableTableCell}>
                    <FileDownloadDoneOutlinedIcon color={"primary"} onClick={(e) => handleSendTest(e, index)}/>
                </td>
            )
        } else {
            return (
                <td className={isHidden('send_test', headers) ? classes.hide : classes.clickableTableCell}>
                    <FileDownloadDoneOutlinedIcon color={"disabled"} />
                </td>
            )
        }
    }

    function getRow() {
        let target_label = "none"
        if (alert_sink.alert_type === 'Email') {
            target_label = alert_sink.recipients
        } else if (alert_sink.alert_type === "AWS SNS") {
            target_label = alert_sink.aws_sns_arn
        }
        else if (alert_sink.alert_type === "Slack") {
            target_label = alert_sink.slack_channel
        }
        else if (alert_sink.alert_type === "Syslog") {
            target_label = alert_sink.syslog_ip + ":" + alert_sink.syslog_port
        }
        if (!isOpen) {
            return (
                <tr
                    key={index} onClick={() => setIsSelected(!isSelected)}
                    className={classes.tableComponent}
                >
                    <td className={isHidden('alert_enabled', headers) ? classes.hide : classes.tableCell}>
                        {getEnabledButton()}
                    </td>
                    <td className={isHidden('alert_type', headers) ? classes.hide : classes.tableCell}>{alert_sink.alert_type}</td>
                    <td className={isHidden('target', headers) ? classes.hide : classes.tableCell}>{target_label}</td>
                    {getSendTestButton()}
                    <td className={isHidden('edit', headers) ? classes.hide : classes.clickableTableCell}>
                        <EditOutlinedIcon color={"primary"} onClick={(e) => toggleOpen()}/>
                    </td>
                    <td className={isHidden('delete', headers) ? classes.hide : classes.clickableTableCell}>
                        <BackspaceOutlinedIcon color={"error"}
                                               onClick={(e) => handleAlertDelete(index)}/>
                    </td>
                </tr>
            )
        } else {
            return (
                <tr
                    key={index} onClick={() => setIsSelected(!isSelected)}
                    className={classes.tableComponent}
                >
                    <td className={isHidden('alert_enabled', headers) ? classes.hide : classes.tableCell}>
                        {getEnabledButton()}
                    </td>
                    <td className={isHidden('alert_type', headers) ? classes.hide : classes.tableCell}>
                        <Select
                            id="alert_type"
                            label="Type"
                            name="alert_type"
                            variant={"outlined"}
                            value={alert_sink.alert_type}
                            onChange={(e) => {
                                console.log("event: " + Object.keys(e));
                                handleAlertChange(index, e);
                            }}
                            classes={{root: classes.whiteColor, icon: classes.whiteColor}}
                            style={{minWidth: 100}}
                        >
                            {alert_type_menu.map((item) =>
                                <MenuItem key={item.value} value={item.value}
                                          disabled={item.disabled}>{item.label}</MenuItem>)}
                        </Select>
                    </td>
                    <td className={isHidden('target', headers) ? classes.hide : classes.tableCell}>{target_label}</td>
                    {getSendTestButton()}
                    <td className={isHidden('edit', headers) ? classes.hide : classes.clickableTableCell}>
                        <EditOutlinedIcon color={"primary"} onClick={(e) => toggleOpen()}/>
                    </td>
                    <td className={isHidden('delete', headers) ? classes.hide : classes.clickableTableCell}>
                        <BackspaceOutlinedIcon color={"error"}
                                               onClick={(e) => handleAlertDelete(index)}/>
                    </td>
                </tr>
            )
        }
    }

    function getDetail() {
        if (alert_sink.alert_type === "Email") {
            return (
                <>
                    <tr>
                        <td></td>
                        <td style={{width: "150px"}}>Email</td>
                        <td style={{width: "400px"}}>
                            <TextField
                                id="recipients"
                                label="Email(s)"
                                name="recipients"
                                variant={"outlined"}
                                type="text"
                                inputProps={{ style: { color: 'lightgray' } }}
                                InputLabelProps={{ style: { color: 'lightgray' } }}
                                value={alert_sink.recipients}
                                onChange={(e) => {
                                    console.log("event: " + Object.keys(e));
                                    handleAlertChange(index, e);
                                }}
                            />
                        </td>
                    </tr>
                </>
            )
        }
        else if (alert_sink.alert_type === "AWS SNS") {
            return (
                <>
                    <tr>
                        <td></td>
                        <td>SNS Queue</td>
                        <td>
                            <TextField
                                id="aws_sns_arn"
                                label="SNS Arn"
                                name="aws_sns_arn"
                                variant={"outlined"}
                                type="text"
                                sx={{ width: 350 }}
                                classes={{ root: classes.whiteColor }}
                                inputProps={{ style: { color: 'lightgray' } }}
                                InputLabelProps={{ style: { color: 'lightgray' } }}
                                value={alert_sink.aws_sns_arn}
                                onChange={(e) => {handleAlertChange(index, e);}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Region</td>
                        <td>
                            <TextField
                                id="region"
                                label="Region"
                                name="region"
                                variant={"outlined"}
                                type="text"
                                inputProps={{ style: { color: 'lightgray' } }}
                                InputLabelProps={{ style: { color: 'lightgray' } }}
                                value={alert_sink.region}
                                onChange={(e) => {handleAlertChange(index, e);}}
                            />
                        </td>
                    </tr>
                </>
            )
        }
        else if (alert_sink.alert_type === "Slack") {
            return (
                <>
                    <tr>
                        <td></td>
                        <td>Channel</td>
                        <td>
                            <TextField
                                id="slack_channel"
                                label="Channel"
                                name="slack_channel"
                                variant={"outlined"}
                                type="text"
                                inputProps={{ style: { color: 'lightgray' } }}
                                InputLabelProps={{ style: { color: 'lightgray' } }}
                                value={alert_sink.slack_channel}
                                onChange={(e) => {handleAlertChange(index, e);}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Token</td>
                        <td>
                            <TextField
                                id="slack_token"
                                label="Token"
                                name="slack_token"
                                variant={"outlined"}
                                type="password"
                                inputProps={{ style: { color: 'lightgray' } }}
                                InputLabelProps={{ style: { color: 'lightgray' } }}
                                value={alert_sink.slack_token}
                                onChange={(e) => {handleAlertChange(index, e);}}
                            />
                        </td>
                    </tr>
                </>
            )
        }
        else if (alert_sink.alert_type === "Syslog") {
            return (
                <>
                    <tr>
                        <td></td>
                        <td>IP</td>
                        <td>
                            <TextField
                                id="syslog_ip"
                                label="IP or FQDN"
                                name="syslog_ip"
                                variant={"outlined"}
                                type="text"
                                inputProps={{ style: { color: 'lightgray' } }}
                                InputLabelProps={{ style: { color: 'lightgray' } }}
                                value={alert_sink.syslog_ip}
                                onChange={(e) => {handleAlertChange(index, e);}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Port</td>
                        <td>
                            <TextField
                                id="syslog_port"
                                label="Port"
                                name="syslog_port"
                                variant={"outlined"}
                                type="number"
                                inputProps={{ style: { color: 'lightgray' } }}
                                InputLabelProps={{ style: { color: 'lightgray' } }}
                                value={alert_sink.syslog_port}
                                onChange={(e) => {handleAlertChange(index, e);}}
                            />
                        </td>
                    </tr>
                </>
            )
        }
        else {
            return (
                <></>
            )
        }
    }

    return (
        <>
            {getRow()}
            {isOpen && getDetail()}
        </>
    )
}

